import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';

const ErrorLog = () => {
  // Sample data generator
  const generateSampleData = (count = 80) => {
    const methods = ['POST', 'GET', 'PUT', 'DELETE', 'PATCH'];
    const statuses = ['200', '201', '400', '401', '403', '404', '422', '500', '502', '503'];
    const userTypes = ['Admin', 'Super Distributor', 'Master Distributor', 'Distributor', 'Retailer', 'API Partner'];
    const uris = [
      '/api/v1/transaction/recharge',
      '/api/v1/user/login',
      '/api/v1/payment/process',
      '/api/v1/wallet/balance',
      '/api/v1/reports/generate',
      '/api/v1/transaction/status',
      '/api/v1/user/register',
      '/api/v1/payment/verify',
      '/api/v1/bill/payment',
      '/api/v1/transfer/money'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      requestUri: uris[i % uris.length],
      method: methods[i % methods.length],
      request: `{"user_id":"USER${String(i + 1).padStart(4, '0')}","amount":${(i + 1) * 100},"mobile":"9${String(i).padStart(9, '0')}"}`,
      response: `{"status":"${statuses[i % statuses.length]}","message":"${statuses[i % statuses.length] === '200' || statuses[i % statuses.length] === '201' ? 'Success' : 'Error occurred'}","timestamp":"${new Date().toISOString()}"}`,
      status: statuses[i % statuses.length],
      mobile: `+91 9${String(i).padStart(9, '0')}`,
      userType: userTypes[i % userTypes.length],
      timestamp: new Date(2024, 10, 4 - Math.floor(i / 10), 12 + Math.floor(i / 5) % 12, (i * 5) % 60)
        .toISOString().replace('T', ' ').substring(0, 19)
    }));
  };

  const [data] = useState(generateSampleData(80));

  // Column definitions (No Actions column)
  const columns = [
    { key: 'requestUri', label: 'Request URI' },
    { key: 'method', label: 'Method' },
    { 
      key: 'request', 
      label: 'Request',
      render: (row) => (
        <details style={{ cursor: 'pointer' }}>
          <summary style={{ color: '#667eea', fontWeight: '500' }}>View Request</summary>
          <div style={{ 
            marginTop: '0.5rem', 
            padding: '0.5rem', 
            background: '#f8f9fa', 
            borderRadius: '4px',
            fontSize: '0.8rem',
            textAlign: 'left',
            wordBreak: 'break-all'
          }}>
            {row.request}
          </div>
        </details>
      )
    },
    { 
      key: 'response', 
      label: 'Response',
      render: (row) => (
        <details style={{ cursor: 'pointer' }}>
          <summary style={{ color: '#667eea', fontWeight: '500' }}>View Response</summary>
          <div style={{ 
            marginTop: '0.5rem', 
            padding: '0.5rem', 
            background: '#f8f9fa', 
            borderRadius: '4px',
            fontSize: '0.8rem',
            textAlign: 'left',
            wordBreak: 'break-all'
          }}>
            {row.response}
          </div>
        </details>
      )
    },
    { key: 'status', label: 'Status' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'userType', label: 'UserType' },
    { key: 'timestamp', label: 'Timestamp' }
  ];

  return (
    <Container fluid className="">
      <SettingsTable
        data={data}
        settingsType="Error Log"
        columns={columns}
      />
    </Container>
  );
};

export default ErrorLog;

